import React from "react";
// import PropTypes from "prop-types";

import PurposesSelect from "../../shared/containers/filters/purposes";
import CountriesSelect from "../../shared/containers/filters/countries";
import ParametersPopover from "../../shared/containers/filters/parameters";
import RegulationsSelect from "../../shared/containers/filters/regulations";
import ShowOnlyRegulationsWithNumericalStandards from "../../shared/containers/filters/show_only_regulations_with_numerical_standards";

class MainFilters extends React.Component {
  render () {
    return (
      <div className="main-filters">
        <div className="row">
          <RegulationsSelect />
          <ShowOnlyRegulationsWithNumericalStandards />
        </div>
        <div className="row">
          <PurposesSelect />
          <CountriesSelect />
          <ParametersPopover />
        </div>
      </div>
    );
  }
}

MainFilters.propTypes = {
  // searchIsBeingSaved: PropTypes.bool.isRequired,
};

export default MainFilters;
